// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"349":"9994627c","409":"67a46164","442":"7e504564","915":"10a5234d"}[chunkId] + ".css";
};